var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitization01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9002 18.3784C24.8492 17.8191 25.4859 16.7866 25.4859 15.6054C25.4859 13.8289 24.0458 12.3888 22.2693 12.3888C20.4929 12.3888 19.0528 13.8289 19.0528 15.6054C19.0528 16.6602 19.5605 17.5963 20.3448 18.1829",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.543 23.5601C28.0055 22.5722 30.5405 19.3848 30.5405 15.6053C30.5405 11.0373 26.8374 7.33419 22.2694 7.33419C17.7013 7.33419 13.9982 11.0373 13.9982 15.6053C13.9982 19.3168 16.4428 22.4574 19.8097 23.5046",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8829 6.42381C32.9005 7.40625 31.3077 7.40625 30.3253 6.42381C29.3429 5.44137 29.3429 3.84862 30.3253 2.86618C31.3077 1.88374 32.9005 1.88374 33.8829 2.86618C34.8654 3.84862 34.8654 5.44137 33.8829 6.42381Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2133 28.3442C13.2309 29.3267 11.6381 29.3267 10.6557 28.3442C9.67326 27.3618 9.67326 25.769 10.6557 24.7866C11.6381 23.8041 13.2309 23.8041 14.2133 24.7866C15.1958 25.769 15.1958 27.3618 14.2133 28.3442Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.543 30.1348C31.5844 29.0418 36.9736 22.9528 36.9736 15.6052C36.9736 12.2738 35.8656 9.20144 33.9983 6.73586",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4079 0.925884C13.6879 1.37187 7.56506 7.7736 7.56506 15.6054C7.56506 18.9622 8.69009 22.0562 10.5835 24.5312",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4375 45.1016V34.3693C38.4375 33.0904 37.4007 32.0536 36.1218 32.0536C34.8429 32.0536 33.8062 33.0904 33.8062 34.3693V32.5274C33.8062 31.2485 32.7694 30.2118 31.4905 30.2118C30.2115 30.2118 29.1747 31.2485 29.1747 32.5274C29.1747 31.2485 28.138 30.2118 26.8591 30.2118C25.5802 30.2118 24.5434 31.2485 24.5434 32.5274V19.9797C24.5434 18.7008 23.5067 17.664 22.2278 17.664C20.9488 17.664 19.912 18.7008 19.912 19.9797V31.0323V40.5937L17.1179 36.0091C16.4309 34.882 14.9702 34.5091 13.8271 35.1691C12.7246 35.8055 12.3 37.1848 12.8536 38.331L16.2051 45.1016",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5434 32.5274V37.043",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1748 32.5275V37.3701",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8062 34.3692V37.4307",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitization01);
export default __webpack_public_path__ + "static/media/Digitization01.3dbb0c27ee5dacf7c046535c67d138a2.svg";
export { ForwardRef as ReactComponent };